import request from '@/utils/request'

/**
 * 获取通知历史列表
 * @param {import('@/types/generated/openapi').paths['/notice/history']['get']['parameters']['query']} params
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/notice/history']['get']['responses']['200']['content']['application/json']>>}
 */
export function getNoticeHistoryList(params) {
  return request({
    url: 'notice/history',
    method: 'get',
    params
  })
}

/**
 * 获取通知历史详情
 * @param {number} id
 * @returns {Promise<import('@/types/utils').R<import('@/types/api').NoticeHistoryItem>>}
 */
export function getNoticeHistoryDetail(id) {
  return request({
    url: `notice/history/${id}`,
    method: 'get'
  })
}

/**
 * 重新发送通知
 * @param {{ history_id: number[] }} data
 * @returns {Promise<import('@/types/utils').R<any>>}
 */
export function retryNotice(data) {
  return request({
    url: 'notice/history/retry',
    method: 'post',
    data
  })
}

/**
 * 获取事件日志列表
 * @param {import('@/types/generated/openapi').paths['/event/log']['get']['parameters']['query']} params
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/event/log']['get']['responses']['200']['content']['application/json']>>}
 */
export function fetchEventLogList(params) {
  return request({
    url: 'event/log',
    method: 'get',
    params
  })
}

/**
 * 获取事件日志详情
 * @param {number} id
 * @returns {Promise<import('@/types/utils').R<any>>}
 */
export function fetchEventLogDetail(id) {
  return request({
    url: `event/log/${id}`,
    method: 'get'
  })
}

/**
 * 获取通知历史统计
 * @param {import('@/types/generated/openapi').paths['/notice/history-statistic']['get']['parameters']['query']} params
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/notice/history-statistic']['get']['responses']['200']['content']['application/json']>>}
 */
export function getNoticeHistoryStatistic(params) {
  return request({
    url: 'notice/history-statistic',
    method: 'get',
    params
  })
}
